import { createFileRoute } from "@tanstack/react-router"
import { DistributorDetail } from "@/components/sensory"

export const Route = createFileRoute("/sensory/distributors/$distributorNumber")({
  staticData: {
    title: 'Distributor Detail',
    isSecured: true,
  },
  component: DistributorDetailPage,
})

function DistributorDetailPage() {
  const { distributorNumber } = Route.useParams()

  return (
    <div className="p-6">
      <DistributorDetail distributorNumber={parseInt(distributorNumber)} />
    </div>
  )
}
